import { useState } from "react";
import { SelectField } from "../../../../common/components/forms/inputs/dropdown/SelectField";
import styles from "./UserSelectionDialog.module.scss";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { ISelectFieldModel } from "../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

interface IUserSelectionDialogProps {
  users?: ISelectFieldModel[];
  onTryReserve: (selectedUserId: number) => void;
}

export const UserSelectionDialog = ({
  users,
  onTryReserve,
}: IUserSelectionDialogProps) => {
  const [selectedId, setSelectedId] = useState(users?.[0]?.id ?? 0);

  if (!users) {
    return;
  }

  return (
    <div className={styles.root}>
      <SelectField
        label="Потребител"
        width="100%"
        options={users}
        value={selectedId}
        onChange={(value: number | null) => setSelectedId(value ?? 0)}
        required
        includeId={false}
      />
      <DefaultButton
        label={"Резервирай"}
        onClick={() => onTryReserve(selectedId)}
        disabled={selectedId === 0}
      />
    </div>
  );
};
